import {createAsyncThunk} from "@reduxjs/toolkit";
import axios from "axios";


import {USER_LOCALSTORAGE_KEY} from "../../../../../../shared/const/localstorage";
import {setHomeWork,} from "../../../../slice/groups/set-lessons-students/set-home-work-slice/setHomeWorkSlice";
import {ApiHomeWorkResponse} from "../../../../types/homeWorkSchema";


export const fetchHomeWork = createAsyncThunk(
    "lessons/fetchLessonsId",
    async (lessonsId:string | undefined, thunkAPI) => {
        try {
            const authToken = localStorage.getItem(USER_LOCALSTORAGE_KEY);
            if (!authToken) {
                throw new Error("No token found in localStorage.");
            }
            const { token } = JSON.parse(authToken);

            const response = await axios.get<ApiHomeWorkResponse>(`/api/lessons/${lessonsId}/homework`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });

            if (response.data && response.data.success) {
                thunkAPI.dispatch(setHomeWork(response.data));
            }
            return response.data;
        } catch (error) {
            console.error('Request failed with an error:', error);
            return thunkAPI.rejectWithValue("error");

        }
    }
);


